import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const init = () => {

    const textSectionMediaElements = gsap.utils.toArray([
        ".section-text-media.section-text-media--media-position-mediaRight.section-text-media--media-expansion-grid .media",
        ".section-text-media.section-text-media--media-position-mediaBelow.section-text-media--media-expansion-grid .media",
    ]);

    const mediaClipPathElements = gsap.utils.toArray([
        ".section-text-on-image .section-text-on-image__media",
    ])

    mediaClipPathElements.forEach((el) => {

            gsap.fromTo(el,
                {
                    transformOrigin: '50% 50%',
                    // clipPath: 'polygon(0% 0%, 100% 0%, 80% 80%, 20% 80%)'
                },
                {
                    scrollTrigger: {
                        trigger: el,
                        scrub: true,
                        start: 'top 80%',
                        end: 'center center',
                        invalidateOnRefresh: true
                    },
                    transformOrigin: '50% 50%',
                    // clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                }
            );
    })

    textSectionMediaElements.forEach(function(elem){

        elem.style.transformOrigin="top center";
        // elem.addEventListener(eventType, () => {

            gsap.fromTo(elem,
                {
                    scale: 1.7,
                    // 'width': '100vw',
                    // 'left': '50%',
                    // 'x': '-50vw',
                },
                {
                    scrollTrigger: {
                        trigger: elem,
                        scrub: true,
                        start: 'top 80%',
                        end: 'center center',
                        invalidateOnRefresh: true
                    },
                    scale: 1
                    // 'width': '100%',
                    // 'left': '50%',
                    // 'x': '-50%',
                }
            );
        // })
    });

    // gsap.utils.toArray([".section-text-on-image .media"]).forEach(function(elem){

    //     elem.style.transformOrigin="top center";

    //     gsap.fromTo(elem,
    //             {
    //                 scale: 2.5,
    //             },
    //             {
    //                 scrollTrigger: {
    //                     trigger: elem,
    //                     scrub: true,
    //                     start: 'top 80%',
    //                     end: 'center center',
    //                     invalidateOnRefresh: true
    //                 },
    //                 scale: 1
    //             }
    //         );
    //     // })
    // });

    // gsap.utils.toArray([".section-text-on-image"]).forEach(function(elem){

    //     elem.style.transformOrigin="top center";

    //     // gsap.set(elem, {padding: '10px' })
    //     // gsap.fromTo(elem,
    //     //         {
    //     //             scale: 1,
    //     //         },
    //     //         {
    //     //             scrollTrigger: {
    //     //                 trigger: elem,
    //     //                 scrub: true,
    //     //                 start: 'top 50%',
    //     //                 markers: true,
    //     //                 end: 'center center',
    //     //                 invalidateOnRefresh: true
    //     //             },
    //     //             scale: 0.9
    //     //         }
    //     //     );
    //     // })
    // });


    // gsap.utils.toArray([".section-text-media.section-text-media--media-position-mediaBelow"]).forEach(function(elem){

    //     const qs = gsap.utils.selector(elem);
    //     const texts = qs('.text > *');

    //     console.log("texts",texts);

    //     gsap.set(texts, { autoAlpha: 0 });

    //     texts.forEach(text => {

    //         gsap.fromTo(text,
    //                 {
    //                     y: '+=100%',
    //                     autoAlpha: 0,
    //                 },
    //                 {
    //                     scrollTrigger: {
    //                         trigger: text,
    //                         scrub: true,
    //                         start: 'top 70%',
    //                         // markers: true,
    //                         end: 'center center',
    //                         invalidateOnRefresh: true
    //                     },
    //                     autoAlpha: 1,
    //                     y: '0',
    //                 }
    //         );
    //     })

    // });


}

export default init;
